import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../platform/permissions/permission.service';

const checkAuth = async (url: string): Promise<boolean> => {
  const authService = inject(AuthService);
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  const ok = await authService.restoreSession();
  if (!ok) {
    await router.navigateByUrl('/auth/login');
    return false;
  }

  if (authService.isTenantSession()) {
    await router.navigateByUrl('/tenant/dashboard');
    return false;
  }

  const path = url.split('?')[0];
  // Always allow the platform shell home so users with zero module grants are not stuck in a redirect loop.
  if (path === '/platform/dashboard') {
    return true;
  }
  if (path.startsWith('/platform') && !permissionService.canAccessPath(path)) {
    await router.navigateByUrl('/platform/dashboard');
    return false;
  }

  return true;
};

export const authGuard: CanActivateFn = (_route, state) => checkAuth(state.url);
export const authChildGuard: CanActivateChildFn = (_route, state) => checkAuth(state.url);
